
import Msg from 'vux/src/components/msg/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

export default {
components: {
msg: Msg,
Divider,
XButton
},
props: ["dataConfig"],
data() {
return {
IsShow: false,

Title: "操作成功",
Desc:
"内容详情，可根据实际需要安排，如果换行则不超过规定长度，居中展现<a href='javascript:void(0);'>文字链接</a>",
Icon: "success",

ButtonList: [










],

btnClose: {
type: "default",
text: "关闭",
onClick: () => {
this.closeWxWindow();
}
}
};
},
created() {





},

methods: {
Show() {
this.IsShow = true;
},
Hide() {
this.IsShow = false;
},

setData(dataItem) {
if (dataItem.Title) {
this.Title = dataItem.Title;
}

if (dataItem.Desc) {
this.Desc = dataItem.Desc;
}

var buttionList = dataItem.ButtonList;
if (!buttionList) return;
if (this.ButtonList.length > 0) {
this.ButtonList.splice(0, this.ButtonList.length);
}
buttionList.forEach(m => {
var skinType = "primary";
if (m.SkinType) {
skinType = m.SkinType;
if (skinType == "warning") {
skinType = "warn";
}
}
var buttonItem = {
type: skinType,
text: m.Text,
dataItem: m,
onClick: () => {
this.onButtonClick(buttonItem);
}
};
this.ButtonList.push(buttonItem);
});

console.log("setData== this.ButtonList", this.ButtonList);
},

setTitle(title = "操作成功") {
this.Title = title;
},

setDesc(desc = "") {
this.Desc = desc;
},

async onButtonClick(buttonItem) {
console.log("onButtonClick-buttonItem", buttonItem);


var btnDataItem = buttonItem.dataItem;
if (!btnDataItem) return;













var actionObj = this.$parent.$getActionObj();

await this.$cmd.ExecuteCmd(btnDataItem, actionObj);
},

closeWxWindow() {
try {
WeixinJSBridge.call("closeWindow");
} catch (e) {
console.log(e);
}
}


















}
};
